import {Component, Input, OnInit} from '@angular/core';
import {CONSTANTS} from '../../../cadens.constants';
import {PieceJointeService} from '../../piece-jointe/piece-jointe.service';
import {AlertService} from 'ng-jhipster';

@Component({
    selector: 'jhi-files-component',
    templateUrl: './files.component.html'
})
export class FilesComponent implements OnInit {

    uploadedFiles = [];
    maxSize = 4000000;

    constructor(private pieceJointeService: PieceJointeService,
                private alertService: AlertService) {
    }

    ngOnInit() {
        this.uploadedFiles.push(CONSTANTS.FORMULAIRE_RECOMMANDATION);
    }

    // Open a file in a new tab when click on it
    openFile(name?: string) {
        if (name == null) {
            name = CONSTANTS.FORMULAIRE_RECOMMANDATION;
        }
        // Get la liste des pièces jointes déjà uploadées
        this.pieceJointeService.openFile(name).subscribe((res) => {
            let fileUrl = URL.createObjectURL(res);
            window.open(fileUrl);
        });
    }

    // When the file is uploaded
    onFileUploaded(event, fileName) {
        this.uploadedFiles[0] = fileName;
        this.alertService.success('cadensApp.parametrage.messages.success', null, null);
    }

    // Before the file is sent to the server for upload
    onBeforeUpload(event, fileName) {
        event.formData.append('name', fileName);
    }
    // Before the file is sent to the server for upload
    onBeforeSend(event) {
        event.xhr.setRequestHeader('X-XSRF-TOKEN', this.getCookie('XSRF-TOKEN'));
    }

    private getCookie(name) {
        let value = '; ' + document.cookie;
        let parts = value.split('; ' + name + '=');
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/parametrage/files/files.component.ts